import cont_match_reg from 'md-base-tools/editor'

export default (content) => {
    return cont_match_reg(content, process.env.VUE_APP_ENV, document.querySelector(".cont-warp").clientWidth, 'project')
}
